import api from "../seller-apis/api";

const loadedScripts = {};
//production
const RAZORPAY_KEY = "rzp_live_6B9kKjM7tYjAnd";//OLD - "rzp_live_1fJH0T2SwUE0vV";
//testing
// const RAZORPAY_KEY = "rzp_test_M9or0JkYOKfGtv";//OLD - "rzp_test_4zmEBXITL3uKRI";

function loadScript(src = "https://checkout.razorpay.com/v1/checkout.js") {
  if (loadedScripts[src]) {
    console.warn(`Script ${src} is already loaded.`);
    return Promise.resolve(true); // Resolve with true since the script is already loaded
  }
  return new Promise((resolve) => {
    const script = document.createElement("script");
    script.src = src;
    script.onload = () => {
      loadedScripts[src] = true;
      resolve(true);
    };
    script.onerror = () => {
      resolve(false);
    };
    document.body.appendChild(script);
  });
}
/**
 * Handle Leads Payment
 * @param {*} amt 
 * @param {*} txType 
 * @param {*} leadId 
 * @returns 
 */
export async function displayRazorpay(amt, txType, leadId) {
  const res = await loadScript();

  if (!res) {
    alert("Razorpay SDK failed to load. Are you online?");
    return;
  }

  return api.customerLeads
    .addWallet({ amount: parseInt(amt), txType, leadId })
    .then((data) => {
        console.log("wwww",data);
    //   if (data.message == "Amount exceeds maximum amount allowed.") {
    //     return result.message;
    //   }
      return new Promise((resolve) => {
        if (!data) {
          alert("Server error. Are you online?");
          return;
        }
        const { razorpayId, transactionId } = data.data.data.record;

        var options = {
          description:
            "Toolsvilla - India's largest online store for Power Tools, Garden Tools, Agriculture Machinery, Hand Tools, Industrial Tools, Automotive Tools, Welding machine, DIY tools and more. Cash on Delivery available. Fast Delivery.",
          image: "https://www.toolsvilla.com/assets/images/main/logo.png",
          currency: "INR",
          key: RAZORPAY_KEY,
          amount: amt * 100,
          order_id: razorpayId,
          name: "Toolsvilla",
          handler: function (response) {
            // Handle successful payment response here
            // console.log("Payment successful:", response);

            // Extract information from the response
            const paymentId = response.razorpay_payment_id;
            // const orderId = response.razorpay_order_id;
            const signature = response.razorpay_signature;

            const param = {
              transactionId: transactionId,
              razorpayId: razorpayId,
              receiptId: paymentId,
              signature
            };
            console.log(param);
            api.customerLeads.rzpCallBack(param).then((data) => {
              resolve(data);
            });
          },
          prefill: {
            email: localStorage.getItem("email"),
            contact: localStorage.getItem("phone"),
            name: localStorage.getItem("name"),
          },
          theme: { color: "#339a99" },
        };
        // console.log(options);
        const paymentObject = new window.Razorpay(options);

        paymentObject.open();
      });
    })
    .catch((err) => {
      console.log("sadx",err.response.data);
      return err.response.data.message;
    });
}
/**
 * Handle Brand Subscription
 * @param {*} plan_id 
 * @param {*} plan_duration 
 * @param {*} amt 
 * @param {*} trademark_id 
 * @returns 
 */
export async function brandSubscriptionPaymentHandler(/*plan_id,*/plan_duration,amt,trademark_id){
  const res = await loadScript();

  if (!res) {
    alert("Razorpay SDK failed to load. Are you online?");
    return;
  }

  return api.brand
    .brandSubscribe({/*plan_id,*/plan_duration, amount: (amt),trademark_reqs_id: trademark_id})
    .then((data) => {
      return new Promise((resolve) => {
        if (!data) {
          alert("Server error. Are you online?");
          return;
        }
        const { razorpayId, transactionId } = data.data.record;

        var options = {
          description:
            "Toolsvilla - India's largest online store for Power Tools, Garden Tools, Agriculture Machinery, Hand Tools, Industrial Tools, Automotive Tools, Welding machine, DIY tools and more. Cash on Delivery available. Fast Delivery.",
          image: "https://www.toolsvilla.com/assets/images/main/logo.png",
          currency: "INR",
          key: RAZORPAY_KEY,
          //subscription_id: razorpayId,
          order_id: razorpayId,
          name: "Toolsvilla",
          handler: function (response) {
            // Handle successful payment response here
            console.log("Payment successful:", response);

            // Extract information from the response
            const paymentId = response.razorpay_payment_id;
            //const subscriptionId = response.razorpay_subscription_id;
            const orderId = response.razorpay_order_id;
            const signature = response.razorpay_signature;
            

            const param = {
              transactionId: transactionId,
              razorpayId: razorpayId,
              status: "paid",
              receiptId: paymentId,
              //subscriptionId,
              orderId,
              signature
            };
            api.brand.brandSubscribeClbk(param).then((data) => {
              resolve({data,status:"paid"});
            });
          },
          prefill: {
            email: localStorage.getItem("email"),
            contact: localStorage.getItem("phone"),
            name: localStorage.getItem("name"),
          },
          theme: { color: "#339a99" },
        };
        console.log(options);
        const paymentObject = new window.Razorpay(options);
        paymentObject.on("payment.failed", function (response) {
          console.error("Payment failed:", response.error);
  
          const param = {
            transactionId: transactionId,
            razorpayId: razorpayId,
            status: "failed",
            receiptId: null,
            errorDescription: response?.error?.description,
          };
  
          api.brand.brandSubscribeClbk(param).then((data) => {
            resolve({data,status:"failed"});
          });
        });
        paymentObject.open();
      });
    })
    .catch((err) => {
      console.log("sadx",err.response.data);
      return err.response.data.message;
    });
}
